<template>
  <div v-frag class="prism-elite-app">
    <CardIeaAppMain colorCard="#0F172A" title="">
      <v-col cols="12" class="pa-0 main-container-glass">
        <!-- Top Navigation Bar -->
        <div class="prism-top-bar d-flex align-center justify-space-between px-8 py-5">
           <div class="d-flex align-center">
            <v-btn
              icon
              @click="$router.push({ name: 'Home' })"
              class="mr-4 glass-btn"
              large
            >
              <v-icon color="primary">mdi-arrow-left-circle-outline</v-icon>
            </v-btn>
             <div>
              <h1 class="text-h6 font-weight-black prism-title mb-0">Comunidad</h1>
              <div class="text-caption grey--text font-weight-medium">Comparte y debate con tus compañeros</div>
            </div>
           </div>
           
           <v-btn 
            v-if="!foro"
            color="primary" 
            class="rounded-xl font-weight-black shadow-glow" 
            @click="create"
            depressed
           >
            <v-icon left>mdi-plus-circle</v-icon>
            CREAR TEMA
           </v-btn>
        </div>

        <v-divider class="prism-divider"></v-divider>

        <v-row no-gutters>
          <!-- Sidebar -->
          <v-col cols="12" md="3" :class="{'d-none d-md-block': foro}" class="pa-6 border-right">
             <!-- Actions for Detail View -->
             <div v-if="foro" class="mb-8">
                <v-btn block text color="primary" class="rounded-xl justify-start mb-2" @click="foro = null">
                   <v-icon left>mdi-chevron-left</v-icon> Volver al Feed
                </v-btn>
                <v-btn block outlined color="primary" class="rounded-xl justify-start mb-2 glass-btn" @click="openParticipants">
                   <v-icon left>mdi-account-group</v-icon> Integrantes
                </v-btn>
                <v-btn v-if="foro.alumno_id == user.IDStB" block outlined color="orange" class="rounded-xl justify-start mb-2 glass-btn" @click="editForum(idForo)">
                   <v-icon left>mdi-pencil-outline</v-icon> Editar Tema
                </v-btn>
                <v-btn v-if="foro.alumno_id == user.IDStB" block outlined color="red" class="rounded-xl justify-start glass-btn" @click="deleteForum">
                   <v-icon left>mdi-delete-outline</v-icon> Eliminar
                </v-btn>
             </div>

             <!-- Access Request -->
             <v-btn 
              v-if="foro && !isParticipant()" 
              block 
              color="success" 
              class="rounded-xl shadow-glow-success mb-8" 
              @click="requestAcess()"
             >
                SOLICITAR ACCESO
             </v-btn>

             <!-- Categories Explorer -->
             <div class="elite-sidebar-section pa-4 rounded-xl">
               <h3 class="text-overline font-weight-black primary--text px-2 mb-4">SECCIONES</h3>
               <v-list dense color="transparent" class="pa-0">
                  <v-list-item 
                    @click="selectCategory(null)" 
                    :input-value="category === null"
                    active-class="primary--text rounded-lg elite-list-active"
                    class="rounded-lg mb-1"
                  >
                    <v-list-item-icon class="mr-3">
                      <v-icon small>mdi-layers-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold">Todas las secciones</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item 
                    v-for="(item, i) in categories" 
                    :key="i" 
                    @click="selectCategory(item)"
                    :input-value="category && category.id === item.id"
                    active-class="primary--text rounded-lg elite-list-active"
                    class="rounded-lg mb-1"
                  >
                    <v-list-item-icon class="mr-3">
                      <v-icon x-small :color="item.color || 'primary'">mdi-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold">{{ item.name }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
               </v-list>
             </div>
          </v-col>

          <!-- Main Feed / Detail -->
          <v-col cols="12" :md="foro ? 9 : 9" class="pa-0 bg-soft-grey min-vh-detail">
            
            <!-- LIST VIEW -->
            <div v-if="!foro" class="pa-8">
               <div class="d-flex align-center justify-space-between mb-8">
                 <h2 class="text-h5 font-weight-black prism-heading">
                   {{ category ? category.name : 'Feed de Temas' }}
                 </h2>
               </div>

               <!-- Empty State -->
               <div v-if="items.length == 0 && show == true" class="text-center py-16">
                  <v-icon size="64" color="primary" class="opacity-20 mb-4">mdi-forum-outline</v-icon>
                  <div class="text-h6 grey--text">No hay temas publicados aquí todavía</div>
                  <v-btn color="primary" text class="mt-2" @click="create">¡Tú puedes ser el primero!</v-btn>
               </div>

               <!-- Feed Grid -->
               <v-row v-else>
                  <v-col v-for="(item, i) in items" :key="i" cols="12">
                     <v-card 
                      flat 
                      class="rounded-xl glass-card-interactive pa-6 d-flex align-center" 
                      @click="openForo(item.id, item)"
                     >
                        <!-- Author Avatar -->
                        <v-avatar size="56" color="primary lighten-5" class="mr-6 elite-avatar-glow">
                           <v-img v-if="item.alumno && item.alumno.imagen" :src="item.alumno.imagen"></v-img>
                           <v-icon v-else color="primary">mdi-account</v-icon>
                        </v-avatar>

                        <div class="flex-grow-1">
                           <div class="d-flex align-center mb-1">
                              <v-chip x-small :color="item.category.color" class="font-weight-black white--text mr-2" label>{{ item.category.name }}</v-chip>
                              <span class="text-caption grey--text font-weight-medium">{{ relativeDate(item.created_at) }}</span>
                           </div>
                           <h3 class="text-subtitle-1 font-weight-bold mb-1 d-flex align-center">
                              {{ item.title }}
                              <v-icon v-if="item.type == 'private'" x-small color="primary" class="ml-2">mdi-lock</v-icon>
                           </h3>
                           <div class="text-caption grey--text d-flex align-center">
                              <span class="font-weight-bold primary--text mr-2">
                                {{ item.alumno ? `${item.alumno.Nombres} ${item.alumno.Apellidos}` : 'Usuario IEA' }}
                              </span>
                           </div>
                        </div>

                        <!-- Stats -->
                        <div class="text-right d-none d-sm-flex align-center ml-4">
                           <div class="mx-3 text-center">
                              <div class="text-h6 font-weight-black primary--text line-height-1">{{ item.comments.length }}</div>
                              <div class="text-tiny grey--text uppercase font-weight-bold">Respuestas</div>
                           </div>
                           <div class="mx-3 text-center">
                              <div class="text-h6 font-weight-black primary--text line-height-1">{{ item.likes }}</div>
                              <div class="text-tiny grey--text uppercase font-weight-bold">Likes</div>
                           </div>
                           <!-- Participants -->
                           <div class="ml-6 px-4 border-left d-none d-md-block">
                              <div class="d-flex align-center">
                                 <v-avatar 
                                  v-for="(p, pi) in item.participants.filter(d => d.status == 1).slice(0, 3)" 
                                  :key="pi" 
                                  size="24" 
                                  class="ml-n2 border-white-small"
                                 >
                                    <v-img v-if="p.alumno && p.alumno.imagen" :src="p.alumno.imagen"></v-img>
                                    <v-avatar v-else color="primary" size="24"><v-icon x-small color="white">mdi-account</v-icon></v-avatar>
                                 </v-avatar>
                                 <span v-if="item.participants.length > 3" class="text-tiny blue--text ml-2 font-weight-bold">+{{ item.participants.length - 3 }}</span>
                              </div>
                           </div>
                        </div>
                        <v-icon color="primary" class="ml-4 opacity-50">mdi-chevron-right</v-icon>
                     </v-card>
                  </v-col>
               </v-row>
            </div>

            <!-- DETAIL VIEW -->
            <div v-else class="pa-0">
               <!-- Detail Content Header -->
               <div class="pa-8 bg-white border-bottom shadow-soft">
                  <div class="d-flex align-center justify-space-between mb-8">
                     <div class="d-flex align-center">
                        <v-avatar size="64" color="primary lighten-5" class="mr-6 elite-avatar-glow">
                           <v-img v-if="foro.alumno && foro.alumno.imagen" :src="foro.alumno.imagen"></v-img>
                           <v-img v-else-if="foro.profesor && foro.profesor.empleado.imagen" :src="foro.profesor.empleado.imagen"></v-img>
                           <v-icon v-else color="primary">mdi-account</v-icon>
                        </v-avatar>
                        <div>
                           <div class="d-flex align-center mb-1">
                              <v-chip x-small :color="foro.category.color" class="font-weight-black white--text mr-2" label>{{ foro.category.name }}</v-chip>
                              <span class="text-caption grey--text font-weight-medium">{{ relativeDate(foro.created_at) }}</span>
                           </div>
                           <h2 class="text-h5 font-weight-black prism-heading">{{ foro.title }}</h2>
                           <div class="text-body-2 primary--text font-weight-bold">
                              {{ foro.alumno ? `${foro.alumno.Nombres} ${foro.alumno.Apellidos}` : 'Usuario IEA' }}
                           </div>
                        </div>
                     </div>
                     <div class="text-right">
                        <div class="d-flex align-center glass-btn rounded-xl px-4 py-2 border">
                           <div class="mr-4">
                              <span class="text-h6 font-weight-black mr-1">{{ foro.likes }}</span>
                              <span class="text-caption grey--text font-weight-bold uppercase">Likes</span>
                           </div>
                           <v-btn icon @click="like" :disabled="liked" color="success" class="mr-1"><v-icon>mdi-thumb-up</v-icon></v-btn>
                           <v-btn icon @click="dislike" :disabled="disliked" color="red"><v-icon>mdi-thumb-down</v-icon></v-btn>
                        </div>
                     </div>
                  </div>

                  <div class="text-body-1 grey--text text--darken-3 mb-8 content-forum" v-html="foro.content"></div>

                  <!-- Media Content -->
                  <div v-if="foro.images.length > 0 || foro.video" class="mb-8 rounded-xl overflow-hidden shadow-glow">
                     <v-carousel 
                      v-if="foro.images.length >= 2 || (foro.images.length == 1 && foro.video)" 
                      hide-delimiters 
                      height="450"
                      class="rounded-xl"
                     >
                        <v-carousel-item 
                          v-for="(img, j) in foro.images.filter(d => d.status == 1)" 
                          :key="j" 
                          :src="img.image"
                        ></v-carousel-item>
                        <v-carousel-item v-if="foro.video">
                           <div class="video-container h-full black d-flex align-center">
                              <video width="100%" controls>
                                 <source :src="foro.video" type="video/mp4">
                              </video>
                           </div>
                        </v-carousel-item>
                     </v-carousel>
                     <v-img v-else-if="foro.images.length == 1" :src="foro.images[0].image" max-height="600" contain class="bg-black"></v-img>
                  </div>
               </div>

               <!-- Comments Section -->
               <div class="pa-8">
                  <div class="d-flex align-center justify-space-between mb-8">
                     <h3 class="text-h6 font-weight-black prism-heading d-flex align-center">
                        <v-icon left color="primary">mdi-comment-text-multiple</v-icon>
                        Conversación ({{ foro.comments.length }})
                     </h3>
                  </div>

                  <!-- Comment Input -->
                  <v-card v-if="isParticipant()" flat class="rounded-xl pa-2 mb-12 elite-sidebar-section box-shadow-none border">
                     <v-textarea 
                      solo 
                      flat 
                      background-color="transparent" 
                      rows="3" 
                      v-model="comment"
                      label="Añade tu respuesta..."
                      hide-details
                      class="elite-comment-input"
                     ></v-textarea>
                     <div class="d-flex justify-end pa-2">
                        <v-btn color="primary" class="rounded-xl font-weight-black shadow-glow px-8" @click="addComment()">ENVIAR REACCIÓN</v-btn>
                     </div>
                  </v-card>
                  <v-alert v-else outlined color="primary" class="rounded-xl border-dashed mb-12">
                     <v-row align="center">
                        <v-col class="grow">Debe ser integrante para comentar en este foro privado.</v-col>
                        <v-col class="shrink"><v-btn color="primary" depressed @click="requestAcess()">Solicitar Acceso</v-btn></v-col>
                     </v-row>
                  </v-alert>

                  <!-- Comments Timeline -->
                  <div v-if="foro.comments.length > 0" class="elite-comments-list pl-4 border-left-dashed">
                     <div v-for="(c, cIndex) in foro.comments" :key="cIndex" class="mb-8 relative c-item">
                        <div class="mb-2 d-flex align-center justify-space-between">
                           <div class="d-flex align-center">
                              <v-avatar size="36" color="primary lighten-5" class="mr-3 border-white-small elite-avatar-glow">
                                 <v-img v-if="c.alumno && c.alumno.imagen" :src="c.alumno.imagen"></v-img>
                                 <v-icon v-else size="18" color="primary">mdi-account</v-icon>
                              </v-avatar>
                              <div>
                                 <span class="text-subtitle-2 font-weight-black mr-2">{{ c.alumno ? `${c.alumno.Nombres}` : 'Estudiante' }}</span>
                                 <span class="text-tiny grey--text font-weight-bold uppercase">{{ gettime(c.updated_at) }}</span>
                              </div>
                           </div>
                           <div class="d-flex align-center">
                              <v-btn icon small @click="likeComment(c)" color="primary" class="mr-2 highlight-btn">
                                 <span class="text-caption font-weight-black mr-1">{{ c.likes }}</span>
                                 <v-icon size="16">mdi-heart-outline</v-icon>
                              </v-btn>
                              <v-btn v-if="c.alumno_id == user.IDStB" icon small color="red" @click="deleteComment(c, cIndex)">
                                 <v-icon size="16">mdi-delete-outline</v-icon>
                              </v-btn>
                           </div>
                        </div>
                        <v-card flat class="pa-4 rounded-xl elite-sidebar-section border">
                           <div class="text-body-2 grey--text text--darken-3" v-html="c.comment"></div>
                        </v-card>
                     </div>
                  </div>
                  <div v-else class="text-center py-10 opacity-30">
                     <v-icon size="48">mdi-comment-outline</v-icon>
                     <div class="text-overline font-weight-black mt-2">Aún no hay respuestas</div>
                  </div>
               </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </CardIeaAppMain>

    <!-- Dialog: Create / Edit Forum -->
    <v-dialog v-model="showForm" max-width="850px" scrollable overlay-color="#0f172a" overlay-opacity="0.9">
      <v-card class="rounded-xl overflow-hidden glass-card-interactive">
        <v-card-title class="primary white--text pa-8">
           <v-icon left color="white" large>mdi-plus-circle-outline</v-icon>
           <div class="prism-heading text-h5 font-weight-black">Nuevo Tema de Discusión</div>
           <v-spacer></v-spacer>
           <v-btn icon dark @click="showForm = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        
        <v-card-text class="pa-8">
           <v-row>
              <v-col cols="12">
                 <v-text-field v-model="title" label="Título del tema" outlined class="elite-input rounded-xl" placeholder="¿De qué quieres hablar?"></v-text-field>
              </v-col>
              <v-col cols="12">
                 <v-textarea 
                  v-model.trim="content" 
                  label="Contenido" 
                  outlined 
                  rows="6" 
                  class="elite-input rounded-xl" 
                  placeholder="Detalla tu idea o pregunta..."
                 >
                    <template slot="append">
                      <div class="d-flex flex-column">
                        <v-btn icon color="primary" @click="uploadFilesEvent()" title="Adjuntar imágenes"><v-icon>mdi-camera-outline</v-icon></v-btn>
                        <v-btn icon color="orange" @click="uploadVideoEvent()" title="Adjuntar video"><v-icon>mdi-video-outline</v-icon></v-btn>
                      </div>
                    </template>
                 </v-textarea>
              </v-col>

              <!-- Media Preview -->
              <v-col cols="12" class="d-flex flex-wrap" v-if="files.length > 0 || video">
                 <div v-for="(file, index) in files" :key="index" class="mr-4 mb-4 relative media-preview-box">
                    <v-img :src="file.id ? file.image : file.url" width="100" height="100" class="rounded-xl shadow-soft"></v-img>
                    <v-btn fab x-small color="red" dark absolute top right class="mt-n2 mr-n2" @click="file.id ? deleteFileThumnail(index, file.id) : deleteFileThumnail(index, null)">
                       <v-icon small>mdi-close</v-icon>
                    </v-btn>
                 </div>
                 <div v-if="video" class="media-preview-box relative">
                    <div class="rounded-xl shadow-soft bg-black d-flex align-center justify-center" style="width: 100px; height: 100px;">
                       <v-icon color="white" large>mdi-video-play</v-icon>
                    </div>
                    <v-btn fab x-small color="red" dark absolute top right class="mt-n2 mr-n2" @click="video = null">
                       <v-icon small>mdi-close</v-icon>
                    </v-btn>
                 </div>
              </v-col>

              <v-col cols="6">
                 <v-select v-model="formCategory" :items="categories" item-text="name" item-value="id" label="Categoría" outlined class="elite-input rounded-xl" return-object></v-select>
              </v-col>
              <v-col cols="6">
                 <v-select v-model="formType" :items="types" item-text="name" item-value="id" label="Visibilidad" outlined class="elite-input rounded-xl" return-object></v-select>
              </v-col>
           </v-row>
           <input id="file-upload" type="file" @change="onFileChange" ref="fileInput" style="display:none" multiple />
           <input id="video-upload" type="file" @change="onVideoChange" ref="fileInputVideo" style="display:none" />
        </v-card-text>

        <v-card-actions class="pa-8 pt-0">
           <v-spacer></v-spacer>
           <v-btn text large color="grey darken-1" class="rounded-xl px-6 mr-4" @click="showForm = false">CANCELAR</v-btn>
           <v-btn color="primary" x-large class="rounded-xl px-12 font-weight-black shadow-glow" @click="addForum">PUBLICAR TEMA</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: Participants -->
    <v-dialog v-model="showParticipants" max-width="500px" scrollable overlay-color="#0f172a" overlay-opacity="0.9">
       <v-card v-if="foro" class="rounded-xl overflow-hidden glass-card-interactive">
          <v-card-title class="pa-6 border-bottom align-center">
             <div class="prism-heading text-h6 font-weight-black">Participantes del Foro</div>
             <v-spacer></v-spacer>
             <v-btn icon @click="showParticipants = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pa-0" style="height: 400px;">
             <v-list class="pa-4 bg-transparent">
                <v-list-item v-for="(p, pi) in list" :key="pi" class="rounded-xl mb-2" :class="{'pending-bg': p.status == 2}">
                   <v-list-item-avatar color="primary lighten-5">
                      <v-img v-if="p.alumno && p.alumno.imagen" :src="p.alumno.imagen"></v-img>
                      <v-icon v-else color="primary">mdi-account</v-icon>
                   </v-list-item-avatar>
                   <v-list-item-content>
                      <v-list-item-title class="font-weight-black d-flex align-center">
                         {{ p.alumno ? `${p.alumno.Nombres} ${p.alumno.Apellidos}` : 'Estudiante' }}
                         <v-chip v-if="p.administrator" x-small color="success" class="ml-2 px-1" label dark>ADMIN</v-chip>
                         <v-chip v-if="p.status == 2" x-small color="orange" class="ml-2 px-1" label dark>PENDIENTE</v-chip>
                      </v-list-item-title>
                   </v-list-item-content>
                   
                   <!-- Admin Actions -->
                   <v-list-item-action v-if="isAdministrator() && user.IDStB !== p.alumno_id" class="d-flex flex-row">
                      <template v-if="p.status == 2">
                         <v-btn icon color="success" @click="accept(p)" small><v-icon>mdi-check-circle-outline</v-icon></v-btn>
                         <v-btn icon color="orange" @click="rejectParticipant(p)" small><v-icon>mdi-close-circle-outline</v-icon></v-btn>
                      </template>
                      <v-btn icon color="red" @click="deleteParticipant(p)" small><v-icon>mdi-delete-outline</v-icon></v-btn>
                   </v-list-item-action>
                </v-list-item>
                <infinite-loading @infinite="infiniteHandler" ref="InfiniteLoading"></infinite-loading>
             </v-list>
          </v-card-text>
          <v-card-actions class="pa-4 border-top justify-center">
             <v-btn v-if="foro.alumno_id !== user.IDStB && isParticipant()" text color="red" @click="leaveForum()">
                <v-icon left>mdi-exit-run</v-icon> Abandonar Foro
             </v-btn>
          </v-card-actions>
       </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import moment from "moment";
import InfiniteLoading from 'vue-infinite-loading';
moment.locale('es')

export default {
    name: "Foro",
    components: {
        // CardIeaApp,
        CardIeaAppMain,
        InfiniteLoading,
    },

    data: () => ({
        categories: [],
        selectedCategory: 0,
        items: [],
        category: null,
        showForm: false,
        formCategory: null,
        formType: null,
        cursos: [],
        curso: '',
        formCourse: null,
        title: '',
        content: '',
        types: [
            { id: 'public', name: 'Público' },
            { id: 'private', name: 'Privado' },
        ],
        video: null,
        selecteds: [],
        files: [],
        limit: 10,
        foro: null,
        comment: '',
        liked: false,
        disliked: false,
        showParticipants: false,
        parts: [],
        participants: [],
        idForo: '',

        idParticipants: null,
        page: 1,
        list: [],
        par: [],
        idForoData: null,
        selctForo: null,
        show: false,

    }),

    mounted() {
        if (this.$store.getters.user.borrado == 1 || this.$store.getters.user.alumno_mora == true) {
            this.$router.push({
                name: "Home"
            });
        }
        this.getCategories();
        this.getForums();
        this.getMateria();
    },

    computed: {
        user() {
            return this.$store.getters.user;
        },
    },

    methods: {

        relativeDate(date) {
            const now = new Date();
            const givenDate = new Date(date);

            // Calcular la diferencia en milisegundos
            const diffTime = now - givenDate;

            // Convertir la diferencia a días
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

            // Calcular meses y años
            const diffMonths =
                now.getFullYear() * 12 +
                now.getMonth() -
                (givenDate.getFullYear() * 12 + givenDate.getMonth());
            const diffYears = now.getFullYear() - givenDate.getFullYear();

            if (diffDays === 0) {
                // Comparar horas para hoy
                const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
                const diffMinutes = Math.floor(diffTime / (1000 * 60));
                if (diffHours === 0) {
                    if (diffMinutes === 0) {
                        return "Hace unos segundos";
                    } else if (diffMinutes === 1) {
                        return "Hace un minuto";
                    } else {
                        return `Hace ${diffMinutes} minutos`;
                    }
                } else if (diffHours === 1) {
                    return "Hace una hora";
                } else {
                    return `Hace ${diffHours} horas`;
                }
            } else if (diffDays === 1) {
                return "Ayer";
            } else if (diffDays < 30) {
                return `Hace ${diffDays} días`;
            } else if (diffMonths < 12) {
                return diffMonths === 1 ? "Hace un mes" : `Hace ${diffMonths} meses`;
            } else {
                return diffYears === 1 ? "Hace un año" : `Hace ${diffYears} años`;
            }
        },
        closeParticipants() {
            this.showParticipants = false
            this.$refs.InfiniteLoading.stateChanger.reset();
        },

        infiniteHandler($state) {
            this.$API
                .get({
                    url: "participants-forum/" + this.idParticipants + "?page=" + this.page,
                }).then(({ data }) => {
                    if (data.length) {
                        this.page += 1;
                        this.list.push(...data)
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                });
            console.log(this.list, 'soy list')
        },

        async getParts() {
            await this.$API
                .get({
                    url: "participants-forum/" + this.idParticipants + "?page=1",
                    data: {}
                })
                .then((res) => {
                    let dato = res;
                    this.parts = dato.data;
                    console.log(this.parts)
                });
        },
        async getMateria() {
            await this.$API
                .get({
                    url: "materia-codigo",
                    data: {}
                })
                .then(res => {

                    let dato = res.data;
                    this.cursos = dato;
                    console.log(this.types, this.cursos)
                });
        },
        create() {
            this.showForm = true
            this.foro = null
        },
        gettime(date_publish) {
            let current_date = moment();
            let published_date = moment(date_publish);
            return (moment.duration(current_date - published_date).humanize())
        },
        deleteFileThumnail(index, id) {
            this.files.splice(index, 1);
            if (id) {
                this.images_deleted.push(id)
                console.log(this.images_deleted)
            }
        },
        async uploadFilesEvent() {
            this.$refs.fileInput.click()
        },
        onFileChange(e) {
            let all = e.target.files;
            let r = this.files;
            [all].forEach((val) => {
                if (r.length < this.limit) {
                    for (const item of val) {
                        if (item.type.match('image.*')) {
                            item.url = URL.createObjectURL(item);
                            r.push(item);
                        }
                    }
                }
            });
            this.files = Array.from(r);
            if (this.limit < this.files.length) {
                alert('El número máximo de imágenes por publicación es ' + this.limit);
                this.files.splice(this.limit, (this.files.length - this.limit))
            }
        },
        onVideoChange(e) {
            let v = e.target.files[0];
            if (v.type.match('video.*')) {
                this.video = v;
            } else {
                alert('Agrega un formato válido de video')
            }
        },
        async getCategories() {
            let categoria_id = this.$route.params.categoria_id

            await this.$API
                .get({
                    url: "forum-categories?plat=bea",
                    data: {}
                })
                .then(e => {
                    e.forEach(element => {
                        this.categories.push(element)
                        if (element.id == categoria_id) {
                            this.category = element
                        }
                    });
                    console.log(this.categories)
                });
        },

        async getForums(category = null) {
            let categoria_id = this.$route.params.categoria_id

            let url = 'forums-by-category/' + categoria_id;
            if (category) {
                this.$router.push({
                    name: "ForoCategoria",
                    params: { categoria_id: category.id }
                });
            }
            await this.$API
                .get({
                    url: url,
                    data: {}
                })
                .then(res => {
                    this.items = res.data;
                    this.show = true;
                    console.log(this.items)
                });
        },

        async getForumsAll() {
            let url = 'forums?plat=bea';
            await this.$API
                .get({
                    url: url,
                    data: {}
                })
                .then(res => {
                    this.items = res.data;
                    this.show = true;
                    console.log(this.items)
                });
        },

        async selectCategory(cat = null) {
            if (cat !== null) {
                this.category = cat;
                this.getForums(cat)
                this.foro = null;
            } else {
                this.category = null;
                this.getForumsAll();
                this.foro = null;
            }
        },
        async openForo(id, selctForo) {
            this.list.length = 0
            this.page = 1
            this.comment = '';
            this.idParticipants = id;
            // this.idForoData = id;
            this.selctForo = selctForo;
            this.par = selctForo.participants;
            this.idForo = id;
            console.log(selctForo)
            let canView = true;
            if (selctForo.type == 'private') {
                let e = selctForo.participants.findIndex(d => { return (d.alumno_id == this.user.IDStB && d.status == 1) });
                if (e == -1) {
                    canView = false;
                    if (confirm('¿Este es un foro privado, te gustaría ser solicitar acceso?')) {
                        this.requestAcess(id);
                    }
                }
            }

            if (canView) {
                this.foro = selctForo
                /*this.$router.push({
                  name: "ForoDetalle",
                  params: {
                    id: id,
                    foro:foro
                  }
                });
                */
            }
        },
        editForum(id) {
            this.parts = [];
            this.getParts(id)
            this.showForm = true;
            this.title = this.foro.title
            this.formCategory = this.foro.category
            this.formType = this.foro.type
            this.content = this.foro.content
            this.files = this.foro.images;
            this.video = this.foro.video;
        },
        getColor() {
            let colors = ['#a7ba38', '#095da1', '#e79029', '#dd404a', '#8fc6dc'];
            let min = 0;
            var max = colors.length;
            var random = Math.floor(Math.random() * (max - min)) + min;
            return colors[random];
        },
        async addForum() {
            if (this.content && this.title && this.formCategory && this.formType) {
                var formData = new FormData();
                formData.append('title', this.title);
                formData.append('forum_category_id', this.formCategory.id);
                formData.append('type', this.formType.id);
                formData.append('content', this.content);

                if (this.files.length > 0) {
                    formData.append('cantidadImagen', this.files.length);
                    let i = 0;
                    for (let file of this.files) {
                        formData.append(`imagen_${i}`, file, file.name);
                        i++;

                    }
                }

                if (this.files.length > 0) {
                    formData.append('cantidadImagen', this.files.length);
                    let i = 0;
                    for (let file of this.files) {
                        formData.append(`imagen_${i}`, file, file.name);
                        i++;

                    }
                }

                if (this.video) {
                    formData.append('video', this.video);
                }

                if (this.selecteds.length > 0) {
                    let taggeds = new Array();
                    this.selecteds.forEach((val) => {
                        if (this.content.includes(val.value)) {
                            taggeds.push(val.id);
                        }
                    });
                    formData.append('tagged', taggeds.join(','));
                }

                formData.append('cod', this.curso.cod);
                console.log(formData);
                let url = this.foro ? 'forums/' + this.foro.id : 'forums'
                await this.$API
                    .post({
                        url: url,
                        data: formData
                    }).then(res => {
                        console.log(res)
                        this.foro = res;
                        this.items.unshift(res);
                        this.title = '';
                        this.content = '';
                        this.files = [];
                        this.video = null;
                        this.showForm = false;
                        this.par = res.participants
                    });
            } else {
                alert('Completa todos los campos')
            }
        },
        async addComment() {
            if (this.comment) {
                var formData = new FormData();
                formData.append('comment', this.comment);
                formData.append('taged', '');
                await this.$API
                    .post({
                        url: "forums-comment/" + this.foro.id,
                        data: formData
                    }).then(res => {
                        console.log(res)
                        res.likes = 0;
                        this.foro.comments.unshift(res);
                        this.comment = '';
                    });
            } else {
                alert('Escribe primero tu comentario')
            }
        },
        async like() {
            await this.$API
                .post({
                    url: "forums-like/" + this.foro.id,
                    data: {}
                }).then(res => {
                    if (res) {
                        this.foro.likes++;
                        this.liked = true;
                    }
                });
        },
        async likeComment(comment) {
            await this.$API
                .post({
                    url: "forums-comment-like/" + comment.id,
                    data: {}
                }).then(res => {
                    if (res) {
                        comment.likes++;
                    }
                });
        },
        async dislike() {
            await this.$API
                .delete({
                    url: "forums-like/" + this.foro.id,
                    data: {}
                }).then(res => {
                    if (res) {
                        this.foro.likes--;
                        this.disliked = true;
                    }
                });
        },
        async uploadVideoEvent() {
            this.$refs.fileInputVideo.click()
        },
        async deleteComment(comment, j) {
            if (confirm('¿Estas seguro de querer eliminar este comentario?')) {
                await this.$API
                    .delete({
                        url: "forums-comment/" + comment.id,
                        data: {}
                    }).then(res => {
                        if (res) {
                            this.foro.comments.splice(j, 1)
                        }
                    });
            }
        },
        async deleteForum() {
            if (confirm('¿Estas seguro de querer eliminar este tema?')) {
                await this.$API
                    .delete({
                        url: "forums/" + this.foro.id,
                        data: {}
                    }).then(res => {
                        if (res) {
                            this.foro = null
                            this.getForums(this.category);
                        }
                    });
            }
        },
        openParticipants() {
            this.showParticipants = true;
        },
        isAdministrator() {
            return (this.par.filter(d => { return (d.alumno_id == this.user.IDStB && d.administrator == 1) }).length > 0) ? true : false
        },
        isParticipant() {
            return (this.par.filter(d => { return (d.alumno_id == this.user.IDStB && d.status == 1) }).length > 0) ? true : false
        },
        async leaveForum() {
            if (confirm('¿Estas seguro de querer salirte de este foro?')) {
                await this.$API
                    .post({
                        url: "forums/leave/" + this.foro.id,
                    }).then(res => {
                        if (res == true) {
                            this.foro = null;
                            this.getForums(this.category);
                        }
                    });
            }
        },
        async requestAcess(id = null) {
            let foroId = id ? id : this.foro.id;
            await this.$API
                .post({
                    url: "forums/access/" + foroId,
                }).then(res => {
                    if (res == true) {
                        alert('Tu solicitud ha sido enviada')
                    }
                });
        },
        async accept(participant) {
            await this.$API
                .post({
                    url: "forums/accept/" + participant.id,
                }).then(res => {
                    if (res == true) {
                        alert('Integrante aceptado')
                        participant.status = 1;
                    }
                });
        },
        async deleteParticipant(participant) {
            await this.$API
                .delete({
                    url: "forum-participant/" + participant.id,
                }).then(res => {
                    if (res == true) {
                        alert('Integrante eliminado')
                        participant.status = 0;
                    }
                });
        },
        async rejectParticipant(participant) {
            await this.$API
                .post({
                    url: "forums/reject/" + participant.id,
                }).then(res => {
                    if (res == true) {
                        alert('Integrante rechazado')
                        participant.status = 0;
                    }
                });
        }
    }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Outfit:wght@700;900&display=swap");

.prism-elite-app {
  font-family: "Inter", sans-serif !important;
  background: radial-gradient(circle at 100% 100%, #0f172a 0%, #1e293b 100%);
  min-height: 100vh;
}

h1, h2, h3, .prism-heading, .text-overline {
  font-family: "Outfit", sans-serif !important;
  letter-spacing: -0.5px;
}

.main-container-glass {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  min-height: 90vh;
}

.prism-top-bar { background: transparent; }
.prism-divider { border-color: rgba(0,0,0,0.05) !important; }

.bg-soft-grey { background: #f8fafc; }
.border-right { border-right: 1px solid rgba(0,0,0,0.05) !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.05) !important; }

/* Elite Sidebar */
.elite-sidebar-section {
  background: white;
  border: 1px solid #f1f5f9;
}

.elite-list-active {
  background: rgba(26, 35, 126, 0.05) !important;
}

/* Elite Cards */
.glass-card-interactive {
  background: white;
  border: 1px solid #f1f5f9 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05) !important;
  cursor: pointer;
}
.glass-card-interactive:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px -15px rgba(26, 35, 126, 0.1) !important;
  border-color: #1a237e !important;
}

.elite-avatar-glow {
  box-shadow: 0 0 15px rgba(26, 35, 126, 0.1);
}

.border-white-small { border: 2px solid white !important; }

/* Detail Specific */
.shadow-soft { box-shadow: 0 4px 20px rgba(0,0,0,0.03) !important; }
.border-left-dashed { border-left: 2px dashed #e2e8f0; }

.elite-comment-input ::v-deep .v-input__control {
  min-height: 0 !important;
}

.highlight-btn:hover { background: rgba(26, 35, 126, 0.05); }

.video-container { width: 100%; border-radius: inherit; }

.shadow-glow {
  box-shadow: 0 10px 20px -5px rgba(26, 35, 126, 0.3) !important;
}

.shadow-glow-success {
  box-shadow: 0 10px 20px -5px rgba(16, 185, 129, 0.3) !important;
}

/* Media preview */
.media-preview-box img { object-fit: cover; }

.min-vh-detail { min-height: 80vh; }

.line-height-1 { line-height: 1; }
.text-tiny { font-size: 0.75rem !important; }
.uppercase { text-transform: uppercase; }

.pending-bg { background: rgba(255, 152, 0, 0.05) !important; }

.opacity-20 { opacity: 0.2; }
.opacity-30 { opacity: 0.3; }
.opacity-50 { opacity: 0.5; }

.box-shadow-none { box-shadow: none !important; }

.border-dashed { border-style: dashed !important; border-width: 2px !important; }

.content-forum { line-height: 1.6; }

/* Responsive adjustments */
@media (max-width: 960px) {
  .border-right { border-right: none !important; border-bottom: 1px solid rgba(0,0,0,0.05) !important; }
}
</style>
